<template>
    <article class="m mx-auto py-8 px-4">
        <header class="mb-6 text-center">
            <div
                class="text-sm font-medium text-orange-500 flex items-center gap-2"
            >
                <Icon icon="security" class="w-5 h-5" />
                <span>Data security</span>
            </div>
            <h1 class="text-2xl font-semibold leading-relaxed mt-2 text-left text-slate-800 dark:text-slate-100">
                We take your data and security seriously.
            </h1>
        </header>
        <div class="mx-auto text-slate-800 dark:text-slate-100 space-y-4 text-sm font-normal">
            <p>Data security is as important to us as it is to you.</p>
            <p>
                Candidly, when transmitting and storing data over the Internet,
                there is no way to guarantee 100% security of that information.
            </p>

            <p>
                However, we take as many measures as possible in order to
                protect your information from unauthorized access as best as
                possible using the most up to date security measures and best
                practices.
            </p>

            <p>Here's how we're working to keep your data safe:</p>

            <h2 class="text-xl font-medium text-slate-800 dark:text-slate-100 pt-2">
                We've Partnered with MX Technologies
            </h2>

            <p>
                We have partnered with MX Technologies, a leading Saas company
                in the financial technology space, to allow you the option to
                securely connect to supported financial institutions.
            </p>

            <p>
                MX works with over 2,000 banks, credit unions, fintechs and more
                to offer secure connections to financial institutions and data.
            </p>

            <p>
                Through this partnership with MX, should you wish to register
                connections with supported institutions, you will be required to
                enter your online banking credentials for that institution.
            </p>

            <p>
                Do note that your credentials never touch My10x servers and are
                not stored by us in any manner. Instead, MX processes them
                directly with the respective institution, and we receive a fully
                encrypted authentication token, which allows us to connect to
                your account and data in order to import it into My10x.
                <strong>This token can be revoked at any time by you</strong>
                in the Manage Connections section of My Wallet in My10.
            </p>

            <p>
                <em>
                    At no time do we have the ability to directly access your
                    account in order to make changes to it.
                </em>
            </p>

            <p>
                As a reminder, we do fully support manual entry of all of this
                data, which doesn't require you to share online banking
                credentials.
            </p>

            <p>
                For more information and specifics on MX's security processes
                and how they protect your data,
                <a
                    href="https://hubspot.mx.com/hubfs/security-whitepaper.pdf"
                    target="_blank"
                    class="text-orange hover:text-orange-400"
                >
                    view this whitepaper.
                </a>
            </p>
            <h2 class="text-xl font-medium text-slate-800 dark:text-slate-100 pt-2">
                Your Data is Encrypted
            </h2>

            <p>
                My10x employs industry-standard encryption protocols to protect
                your data both in transit and at rest. This means that your
                information is encrypted when it's being transmitted between
                your device and our servers, as well as when it's stored in our
                databases.
            </p>

            <h2 class="text-xl font-medium text-slate-800 dark:text-slate-100 pt-2">
                Two-Factor Authentication
            </h2>

            <p>
                My10x offers Two-Factor Authentication (2FA) as an additional
                security option for users. While not impenetrable, with 2FA
                enabled, every time you login, we'll send you a random 6-digit
                code via SMS to help verify your identity.
            </p>

            <p>
                This means that even if someone were to obtain your password,
                they would still need physical access to your mobile device to
                gain access to your account.
            </p>

            <p>
                We strongly recommend enabling 2FA for an added layer of
                security.
            </p>
        </div>
    </article>
</template>

<script setup>
import Icon from '@/components/ui/icon/icon.vue';
</script>
